














































import { Component, Vue, Watch } from "vue-property-decorator";
import Designer from "@/views/Designer.vue";
import Header from "@/components/designer/header/Header.vue";
@Component({
  components: {
    Designer,
    Header,
  },
})
export default class App extends Vue {
  get staging(): boolean {
    if (process.env.VUE_APP_ENV === "staging") {
      return true;
    } else {
      return false;
    }
  }

  get isTouchDevice(): boolean {
    return (
      window.matchMedia("(pointer: coarse)").matches &&
      window.matchMedia("(hover: none)").matches
    );
  }

  get isPhone(): boolean {
    const { width, height } = this.$vuetify.breakpoint;
    return Math.min(width, height) <= 600;
  }

  get isPortrait(): boolean {
    return this.$vuetify.breakpoint.height > this.$vuetify.breakpoint.width;
  }

  get isSmallScreen(): boolean {
    if (!this.isTouchDevice) return false;
    return this.isPhone || this.isPortrait;
  }

  @Watch("isSmallScreen", { immediate: true })
  onSmallScreenChange(isSmall: boolean): void {
    if (!isSmall) return;
    this.$nextTick(() => {
      document.querySelectorAll(".vld-overlay").forEach(el => el.remove());
    });
  }

  get showRotatePrompt(): boolean {
    return !this.isPhone && this.isPortrait;
  }
}
